<template>
  <div class="k-category">
    <div :class="`icon -${category.color}`">
      <k-icon
        :icon="category.icon"
        :iconColor="iconColor"
        viewBox="0 0 24 24"
        :width="32"
        :height="32"
      />
    </div>
    <div class="content">
      {{category.name}}
    </div>
  </div>
</template>

<script>
import KIcon from './KIcon.vue';
export default {
  components: { KIcon },
  name: 'KCategory',
  props: {
    category: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    iconColor () {
      switch (this.category.color) {
        case 'primary-1':
          return '#00b2e3'
        case 'primary-2':
          return '#00b770'
        case 'primary-3':
          return '#3978ee'
        case 'primary-4':
          return '#7973da'
        case 'primary-5':
          return '#ff4DCC'
        case 'primary-6':
          return '#ff6362'
        case 'primary-7':
          return '#ff8e03'
        case 'primary-8':
          return '#ffd103'
        default:
          return '#4DBCD4'
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import "@/assets/scss/main.scss";;

.k-category {
  display: flex;
  align-items: center;
  .icon {
    width: 50px;
    height: 50px;
    padding: $spacing-xs;
    border-radius: 10px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.-primary-1 {
      background: $category-1;
    }
    &.-primary-2 {
      background: $category-2;
    }
    &.-primary-3 {
      background: $category-3;
    }
    &.-primary-4 {
      background: $category-4;
    }
    &.-primary-5 {
      background: $category-5;
    }
    &.-primary-6 {
      background: $category-6;
    }
    &.-primary-7 {
      background: $category-7;
    }
    &.-primary-8 {
      background: $category-8;
    }
    &.-primary-9 {
      background: $category-9;
    }
  }
  .content {
    @include body-1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/KCategory.vue